export enum CourseSimilarEvent {
  goToCoursePageBlockSimilarCourses = 'go_to_course_page_block_similar_courses',
}

export enum CourseSimilarEventPosition {
  coursePageBlockSimilarCourses = 'course_page_block_similar_courses',
}
